import { useSelector } from "react-redux";
import { StoreType } from "../../../core/store/reducers";
import { OrderStatus } from "../../models";

const getStatusLabel = (status?: OrderStatus) => (status ? status.ftDescr : "");

export const useTradeStatuses = () => {
	const statuses = useSelector<StoreType, OrderStatus[]>(store => store.data.initialData.tradeStatuses);

	return [statuses, getStatusLabel] as [typeof statuses, typeof getStatusLabel];
};
